export default __webpack_public_path__ + "static/media/Logo-colour-simple-bluecolor.582c5c0d.png";